<mat-card appearance="outlined" data-cy="patient-main-card">
  <mat-card-header data-cy="patient-card-header">
    <mat-card-title data-cy="patient-card-title">
      {{ thePatient?.PatientNameEnumSalutation }}
      {{ thePatient?.ThePatient.dataContact.FirstName}}
      {{ thePatient?.ThePatient.dataContact.MidName }}
      {{ thePatient?.ThePatient.dataContact.LastName}}
    </mat-card-title>
  </mat-card-header>

  <mat-card-actions data-cy="patient-card-actions">
    <div data-cy="patient-action-buttons-container">
      <button (click)="openDialogPatientNew()" aria-label="New patient" mat-raised-button
              matTooltip="Create new patient" data-cy="patient-new-patient-action-button">
        <mat-icon data-cy="patient-new-patient-action-icon">person_add</mat-icon>
      </button>
      <button (click)="openDialogPatientEdit()" aria-label="Edit patient" mat-raised-button
              matTooltip="Edit current patient" data-cy="patient-edit-patient-action-button">
        <mat-icon data-cy="patient-edit-patient-action-icon">person</mat-icon>
      </button>
      <button (click)="openDialogPatientFind()" aria-label="Find patient" mat-raised-button
              matTooltip="Search for / Find patient" data-cy="patient-find-patient-action-button">
        <mat-icon data-cy="patient-find-patient-action-icon">search</mat-icon>
      </button>
    </div>
  </mat-card-actions>

  <mat-card-content data-cy="patient-card-content">
    <mat-icon *ngIf="!thePatient" color="primary" style="font-size:200px; margin-left: 15px;" data-cy="patient-identity-icon">perm_identity</mat-icon>
    <img *ngIf="thePatient" [src]="thePatient?.PatientImageFullPath" class="card-img-top" style="width:100%;" data-cy="patient-image">
  </mat-card-content>

  <mat-card-footer data-cy="patient-card-footer">
    <span data-cy="patient-dob-label">DOB:</span>
    <span data-cy="patient-dob-value">{{  thePatient?.ThePatient.BirthDate | date }}</span>
    <span data-cy="patient-age-value">    &#40;
    {{  thePatient?.ThePatient.BirthDate  | dob2age | number:'1.0-0' }}
    &#41;</span>
    <span data-cy="patient-gender-value">{{ thePatient?.PatientEnumGender}}</span>
  </mat-card-footer>
</mat-card>


